import { createSlice } from "@reduxjs/toolkit";

interface ProfileState {
  profile: {
    emails: {email:string}[];
    birth: {
       date: string,
    }
    name: {
      firstName: string;
      lastName: string;
      middleName: string;
    };
  };
}

const initialState: ProfileState = {
  profile: {
    emails: [],
    birth: {
      date: ""
    },
    name: {
      firstName: "",
      lastName: "",
      middleName: "",
    },
  },
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    fetchProfile(state, action) {
      state.profile = action.payload;
    },
  },
});

export const { fetchProfile } = profileSlice.actions;
export default profileSlice.reducer;
